import { Flex, Typography } from "antd";

import { CustomButton } from "ui";
import { ListStoreConstructor } from "stores/ListStoreConstructor";
import ShapeContent from "images/table/ShapeContent.svg";

import styles from "../table.module.css";

interface IProps {
  store: ListStoreConstructor<any>;
}

export const TableError = (props: IProps) => {
  return (
    <Flex vertical gap="large" className={styles.emptyTableContent}>
      <Flex vertical>
        <Flex justify="center">
          <img src={ShapeContent} alt="Технические неполадки" className={styles.toolIcon} />
        </Flex>
        <Typography.Title className={styles.tableErrorMessage}>Не удалось загрузить данные</Typography.Title>
        <Typography.Text>Уже исправляем. Попробуйте еще раз или зайдите позже</Typography.Text>
      </Flex>
      <Flex justify="center">
        <CustomButton onClick={() => props.store.fetch()} size="middle" type="default">
          Попробовать еще раз
        </CustomButton>
      </Flex>
    </Flex>
  );
};
